import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getBackgroundToken, getTextToken } from "../fundations/palette/colorTokens";
export const Avatar = {
    MuiAvatar: {
        defaultProps: {
            color: "primary"
        },
        styleOverrides: {
            root: ({ theme })=>({
                    background: getBackgroundToken("backgroundTertiary", theme),
                    color: getTextToken("textBody", theme),
                    ".MuiAvatar-fallback": {
                        background: `url(${DefaultAvatar}) center no-repeat`,
                        backgroundSize: "100% 100%",
                        width: "100%",
                        height: "100%",
                        path: {
                            display: "none"
                        }
                    }
                })
        }
    }
};
const DefaultAvatar = ()=>{
    return /*#__PURE__*/ _jsxs("svg", {
        width: "64",
        height: "64",
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ _jsx("g", {
                id: "Avatar-base",
                children: /*#__PURE__*/ _jsxs("g", {
                    clipPath: "url(#clip0_1786_8205)",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
                            fill: "#94979E"
                        }),
                        /*#__PURE__*/ _jsx("g", {
                            id: "Placeholder",
                            children: /*#__PURE__*/ _jsxs("g", {
                                id: "vector",
                                children: [
                                    /*#__PURE__*/ _jsx("path", {
                                        d: "M32 35.2C37.302 35.2 41.6 30.9019 41.6 25.6C41.6 20.2981 37.302 16 32 16C26.698 16 22.4 20.2981 22.4 25.6C22.4 30.9019 26.698 35.2 32 35.2Z",
                                        fill: "#F1F2F4"
                                    }),
                                    /*#__PURE__*/ _jsx("path", {
                                        d: "M52.9811 56.1625C50.166 47.2563 41.8369 40.8 32 40.8C22.1629 40.8 13.8338 47.2563 11.0189 56.1625C10.357 58.2569 10 60.4868 10 62.8C10 63.2026 10.0109 63.6027 10.0322 64H53.9678C53.9891 63.6027 54 63.2026 54 62.8C54 60.4868 53.643 58.2569 52.9811 56.1625Z",
                                        fill: "#F1F2F4"
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("defs", {
                children: /*#__PURE__*/ _jsx("clipPath", {
                    id: "clip0_1786_8205",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
};

//# sourceMappingURL=Avatar.js.map